import toast from 'react-hot-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
	getConfirmedGrafts,
	updateConfirmedGraft,
} from '@/services/confirmedGrafts';
import type { FilterType } from '@/types/table';

export const useGetConfirmedGrafts = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	port = ''
}: FilterType) => {
	const payload = {
		page,
		limit,
		columnsFilters,
		search,
		globalFilters,
		sort: sort || '',
		port,
	};

	return useQuery({
		queryKey: ['grafts-to-assign', payload],
		queryFn: () => getConfirmedGrafts(payload),
		enabled,
		keepPreviousData: false,
	});
};

export const useUpdateConfirmedGraft = (
	onSuccess?: () => void,
	onError?: (error: unknown) => void,
) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: updateConfirmedGraft,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['grafts-to-assign'] });
			onSuccess?.();
		},
		onError: (error: unknown) => {
			onError?.(error);
			toast.error(
				(error as any)?.response?.data?.error?.message?.error?.message ||
					'Failed to update confirmed graft. Please try again.',
			);
		},
	});
};
